import { noticesReducer } from "./notices";
import { testDrivesReducer } from "./testDrives";
import { contactsReducer } from "./contacts";

export default (state = {}, action) => ({
  ...state,

  notices: noticesReducer(state.notices, action),
  testDrives: testDrivesReducer(state.testDrives, action),
  contacts: contactsReducer(state.contacts, action),
});



// WEBPACK FOOTER //
// ./src/store/index.js